import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ServiceGrid from '../components/ServiceGrid';

const COMMERCIAL_SERVICES = [
  'Concrete Cleaning',
  'Graffiti Removal',
  'Window Cleaning',
  'Sidewalk Cleaning',
];

const Commercial = () => (
  <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <SEO 
      title="Commercial Pressure Washing for Businesses | Phoenix Area"
      description="Impress clients with professional commercial pressure washing in Phoenix, Scottsdale, and beyond. Reliable, high-quality cleaning. Request a quote now!"
      keywords="commercial pressure washing, business cleaning, Phoenix, Scottsdale, exterior cleaning, property maintenance, Copper Canyon Pressure Wash, free quote"
    />
    {/* Hero/Banner */}
    <section className="w-full h-48 sm:h-64 md:h-80 lg:h-96 mb-8 rounded-lg overflow-hidden bg-gray-200 flex items-center justify-center" aria-label="Commercial Banner">
      <picture>
        <source srcSet="/phoenix_hero.avif" type="image/avif" />
        <source srcSet="/phoenix_hero.webp" type="image/webp" />
      <img 
        src="/phoenix_hero.jpeg" 
        alt="Commercial pressure washing services" 
        className="w-full h-full object-cover object-center" 
          width="1600"
          height="400"
      />
      </picture>
    </section>
    <div className="max-w-3xl mx-auto text-center mb-12">
      <h1 className="text-4xl font-bold text-[#4a3f35] mb-4">Commercial Services</h1>
      <p className="text-lg text-gray-700 mb-4">
        Make a lasting impression on your clients, tenants, and visitors with our professional commercial pressure washing and exterior cleaning services. We serve businesses, HOAs, and property managers throughout the Phoenix area with reliable, high-quality cleaning solutions.
      </p>
    </div>
    <section className="mb-16">
      <h2 className="text-2xl font-semibold text-[#b87c4c] mb-6 text-center">Our Commercial Services</h2>
      <ServiceGrid services={COMMERCIAL_SERVICES} />
    </section>
  </main>
);

export default Commercial; 